import { toast } from "react-toastify";

export const updateTravelDocs = async (documentDetails) => {
  let url = `${process.env.REACT_APP_BASE_URL_PHP}controller/actionsController.php`;
  let requestOptions = {
    method: "POST",
    // redirect: "follow",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      payload: documentDetails,
      action_type: "UPDATETRAVELDOCS",
    }),
  };

  try {
    const response = await fetch(url, requestOptions);
    const result = await response.json();
    if (response.status !== 200) {
      throw new Error(result.message);
    }
    return result;
  } catch (error) {
    throw error;
  }
};

export const updateContactDetails = async (contactDetails) => {
  let url = `${process.env.REACT_APP_BASE_URL_PHP}controller/actionsController.php`;
  let requestOptions = {
    method: "POST",
    // redirect: "follow",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      payload: contactDetails,
      action_type: "UPDATEGUESTDETAILS",
    }),
  };
  try {
    const response = await fetch(url, requestOptions);
    const result = await response.json();
    if (response.status !== 200) {
      throw new Error(result.message);
    }
    return result;
  } catch (error) {
    throw error;
  }
};

export const sendOTP = async (booking_id, guest_id) => {
  let url = `${process.env.REACT_APP_BASE_URL_PHP}controller/actionsController.php`;
  let requestOptions = {
    method: "POST",
    redirect: "follow",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      payload: {
        booking_id: booking_id,
        guest_id: guest_id,
      },
      action_type: "SENDOTP",
    }),
  };
  try {
    const response = await fetch(url, requestOptions);
    const result = await response.json();
    if (response.status !== 200) {
      throw new Error(result.message);
    }
    return result;
  } catch (error) {
    throw error;
  }
};

export const validateBooking = async ({ booking_id, last_name }) => {
  let url = `${process.env.REACT_APP_BASE_URL_PHP}controller/actionsController.php`;
  let requestOptions = {
    method: "POST",
    // redirect: "follow",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      payload: {
        booking_id: booking_id,
        last_name: last_name,
      },
      action_type: "VALIDATEBOOKING",
    }),
  };
  try {
    const response = await fetch(url, requestOptions);
    const result = await response.json();
    if (result.status === "success") {
      return sendOTP(booking_id, result.guest_id).then((res) => {
        if (res.status === "success") {
          res.email = result.email;
          res.mobile_no = result.mobile_no;
          res.booking_id = booking_id;
          res.guest_id = result.guest_id;
          return res;
        }
      });
    } else if (result.status === "failed") toast.error(result.message);
    if (response.status !== 200) {
      throw new Error(result.message);
    }
  } catch (error) {
    throw error;
  }
};

export const payDuePayment = async (payload) => {
  let url = `${process.env.REACT_APP_BASE_URL_PHP}controller/actionsController.php`;
  let requestOptions = {
    method: "POST",
    redirect: "follow",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      payload: payload,
      action_type: "DUEPAYMENT",
    }),
  };
  try {
    const response = await fetch(url, requestOptions);
    const result = await response.json();
    if (response.status !== 200) {
      throw new Error(result.message);
    }
    return result;
  } catch (error) {
    throw error;
  }
};

export const resendBookingID = async (email, last_name) => {
  let url = `${process.env.REACT_APP_BASE_URL_PHP}controller/actionsController.php`;
  let requestOptions = {
    method: "POST",
    redirect: "follow",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      payload: {
        email: email,
        last_name: last_name,
      },
      action_type: "RESENDBOOKINGCONFIRMATION",
    }),
  };
  try {
    const response = await fetch(url, requestOptions);
    const result = await response.json();
    if (response.status !== 200) {
      throw new Error(result.message);
    }
    return result;
  } catch (error) {
    throw error;
  }
};
